export default "/fonts/vendor/@fontsource/lato/files/lato-latin-900-normal.woff2?4b21d625362d4f7d84d2cb0f1ce38fb7";